import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import React from 'react';
import { CoreListingRelatedBuyingGuide } from '@reverbdotcom/commons/src/gql/graphql';
import relatedBuyingGuide from '../related_buying_guide';
import CmsPageCards, { CMS2_PAGE } from '@reverbdotcom/commons/src/cms/components/cms_page_cards';
import { IUserContext, IUser, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface IProps {
  listingId: string;
  user: IUser;
}

export class ItemRelatedBuyingGuide extends React.Component<
ChildProps<IProps & IUserContext, CoreListingRelatedBuyingGuide.Query>
> {

  buyingGuideSlug() {
    return relatedBuyingGuide(
      this.props.data.listing.make,
      this.props.data.listing.model,
      this.props.data.listing.categories,
      this.props.user,
    );
  }

  render() {
    if (this.props.data.loading) return null;
    if (!this.props.data.listing) return null;

    const slug = this.buyingGuideSlug();

    if (!slug) return null;
    return (
      <div
        className="product-sidebar__buying-guides"
      >
        <CmsPageCards
          pageFields={[
            { pageSource: CMS2_PAGE, slug },
          ]}
          layoutSection="sidebar"
        />
      </div>
    );
  }
}

const connect = withGraphql<IProps, CoreListingRelatedBuyingGuide.Query>(
  gql`
    query Core_Listing_RelatedBuyingGuide(
      $id: String
    ) {
      listing(
        input: {id: $id}
      ) {
        _id
        model
        make
        categories {
          _id
          name
          slug
        }
      }
    }
  `,
  {
    options: (ownProps) => {
      return {
        ssr: false, // not important for SEO or initial page rendering
        variables: {
          id: ownProps.listingId,
        },
      };
    },
  },
);

export default withUserContext<IProps>(connect(ItemRelatedBuyingGuide));
